<template>
    <div class="modal-row2 modal-height-max">
        <ul class="nav nav-tabs p-2" id="myTab" role="tablist" v-if="!widthMd(500)">
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2"
                 :style="{backgroundColor: configPosOne.backgroundColor}" style="padding: 0">
                <li class="nav-item" role="presentation">
                    <a class="nav-link" :class="{ active: activeTab === 0 }" @click="activeTab = 0"
                       id="position_one-tab"
                       :style="{backgroundColor: activeTab === 0 ? configPosOne.backgroundColor + '!important' : ''}"
                       data-toggle="tab" href="#position_one" role="tab" aria-controls="position_one"
                       aria-disabled="true">{{ configPosOne.label }}</a>
                </li>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2"
                 :style="{backgroundColor: configPosTwo.backgroundColor}" style="padding: 0">
                <li class="nav-item" role="presentation">
                    <a class="nav-link" :class="{ active: activeTab === 1 }" @click="activeTab = 1"
                       id="position_two-tab" data-toggle="tab" href="#position_two" role="tab"
                       :style="{backgroundColor: activeTab === 1 ? configPosTwo.backgroundColor + '!important' : ''}"
                       aria-controls="position_two"
                       aria-disabled="true">{{ configPosTwo.label }} </a>
                </li>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2"
                 :style="{backgroundColor: configPosThree.backgroundColor}" style="padding: 0">
                <li class="nav-item" role="presentation">
                    <a class="nav-link" :class="{ active: activeTab === 2 }" @click="activeTab = 2"
                       id="position_three-tab" data-toggle="tab" href="#position_three" role="tab"
                       :style="{backgroundColor: activeTab === 2 ? configPosThree.backgroundColor + '!important' : ''}"
                       aria-controls="position_three"
                       aria-disabled="true">{{ configPosThree.label }}</a>
                </li>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2"
                 :style="{backgroundColor: configPosFour.backgroundColor}" style="padding: 0">
                <li class="nav-item" role="presentation">
                    <a class="nav-link" :class="{ active: activeTab === 3 }" @click="activeTab = 3"
                       id="position_four-tab" data-toggle="tab" href="#position_four" role="tab"
                       :style="{backgroundColor: activeTab === 3 ? configPosFour.backgroundColor + '!important' : ''}"
                       aria-controls="position_four"
                       aria-disabled="true">{{ configPosFour.label }}</a>
                </li>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2"
                 :style="{backgroundColor: configPosFive.backgroundColor}" style="padding: 0">
                <li class="nav-item" role="presentation">
                    <a class="nav-link" :class="{ active: activeTab === 4 }" @click="activeTab = 4"
                       id="position_five-tab" data-toggle="tab" href="#position_five" role="tab"
                       :style="{backgroundColor: activeTab === 4 ? configPosFive.backgroundColor + '!important' : ''}"
                       aria-controls="position_five"
                       aria-disabled="true">{{ configPosFive.label }}</a>
                </li>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2" style="padding: 0">
                <li class="nav-item" role="presentation">
                    <a class="nav-link" :class="{ active: activeTab === 5 }" @click="activeTab = 5"
                       id="send_data-tab" data-toggle="tab" href="#send_data" role="tab" aria-controls="send_data"
                       aria-disabled="true">Dados Envio</a>
                </li>
            </div>
        </ul>

        <div v-if="loading" class="text-center p-4">
            <div class="spinner-border" role="status">
                <span class="visually-hidden"></span>
            </div>
        </div>

        <form @submit.prevent="generatePriceTable" v-else>
            <div class="tab-content modal-body" id="myTabContent">

                <div class="tab-pane fade p-4" :class="{ active: activeTab === 0, show: activeTab === 0 }"
                     id="position_one"
                     role="tabpanel" aria-labelledby="position_one-tab">
                    <div class="row gutters config-details">
                        <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12">
                            <div>Valor mínimo de {{ configPosOne.label }}: <b>{{ getLabelValue() }}</b></div>
                            <div>Periodicidade: <b>{{ configPosOne.periodicity }}</b></div>
                            <div>Forma de Pagamento: <b>{{ configPosOne.paymentForm }}</b></div>
                            <div>Parcela Mínima para Aplicar Juros na Venda: <b>
                                {{ configPosOne.minInstallmentsForInterest }} </b></div>
                            <div>Juros na Venda se Quantidade de Parcelas Maior ou Igual: <b>
                                {{ configPosOne.initialInterestInstallment }} </b></div>
                            <div>Quantidade Mínima de Parcelas: <b>{{ configPosOne.minQuantityInstallment }}</b></div>
                            <div>Quantidade Máxima de Parcelas: <b> {{ configPosOne.maxQuantityInstallment }} </b></div>
                            <div>Juros: <b>{{ configPosOne.interest }}%</b></div>
                        </div>

                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                            <div class="form-group">
                                <label class="required" for="parcelsQuantity">Quantidade de Parcelas: </label>
                                <input type="text" id="parcelsQuantity"
                                       v-model="inputPosOne.parcelsQuantity" name="parcelsQuantity"
                                       class="form-control" placeholder="20,60">
                                <small class="text-muted">Mínimo: {{ configPosOne.minQuantityInstallment || 1 }},
                                    Máximo:
                                    {{ configPosOne.maxQuantityInstallment || 'Ilimitado' }}</small>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tab-pane fade p-4" :class="{ active: activeTab === 1, show: activeTab === 1 }"
                     id="position_two"
                     role="tabpanel" aria-labelledby="position_two-tab">
                    <div class="row gutters config-details">
                        <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12">
                            <div>Valor mínimo de {{ configPosTwo.label }}: <b>{{ getLabelValue() }}</b></div>
                            <div>Periodicidade: <b>{{ configPosTwo.periodicity }}</b></div>
                            <div>Forma de Pagamento: <b>{{ configPosTwo.paymentForm }}</b></div>
                            <div>Parcela Mínima para Aplicar Juros na Venda: <b>
                                {{ configPosTwo.minInstallmentsForInterest }} </b></div>
                            <div>Juros na Venda se Quantidade de Parcelas Maior ou Igual: <b>
                                {{ configPosTwo.initialInterestInstallment }} </b></div>
                            <div>Quantidade Mínima de Parcelas: <b>{{ configPosTwo.minQuantityInstallment }}</b></div>
                            <div>Quantidade Máxima de Parcelas: <b> {{ configPosTwo.maxQuantityInstallment }} </b></div>
                            <div>Juros: <b>{{ configPosTwo.interest }}%</b></div>
                        </div>

                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                            <div class="form-group">
                                <label class="required" for="parcelsQuantity">Quantidade de Parcelas: </label>
                                <input type="text" id="parcelsQuantity"
                                       v-model="inputPosOne.parcelsQuantity" name="parcelsQuantity"
                                       class="form-control" placeholder="20,60">
                                <small class="text-muted">Mínimo: {{ configPosOne.minQuantityInstallment || 1 }},
                                    Máximo:
                                    {{ configPosOne.maxQuantityInstallment || 'Ilimitado' }}</small>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="modal-footer justify-content-end">
                <div>
                    <button class="btn btn-secondary mr-2" type="button" data-dismiss="modal">Cancelar</button>
                    <button class="btn btn-primary">Gerar Tabela</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>

import {useI18n} from 'vue-i18n';
import {useToast} from 'vue-toastification';
import {Money3Directive} from 'v-money3';
// import Select2 from 'vue3-select2-component';
import paymentMethods from '@/services/paymentMethods';

export default {
    name: 'priceTableComponent',

    components: {
        // Select2,
    },

    directives: {
        money3: Money3Directive,
    },

    emits: ['close'],

    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast};
    },

    data() {
        return {
            loading: true,
            activeTab: 0,
            simulatorConfig: null,
            inputPosOne: {},
            inputPosTwo: {},
            inputPosThree: {},
            inputPosFour: {},
            inputPosFive: {},
            periodicityOptions: {1: 'Mensal', 3: 'Trimestral', 6: 'Semestral', 12: 'Anual'},
            paymentForms: [],

            configCurrencyValue: {
                suffix: '',
                decimal: ',',
                number: true,
                masked: true,
                thousands: '.',
                prefix: 'R$ ',
                disabled: false,
                max: 100000000000,
                minimumNumberOfCharacters: 1,
            },

            formValues: {
                entrance: 0,
                arras: 0,
                brokerage: 0,
                regularInstallments: 0,
                intermediateInstallments: 0,
                formula: 'PRICE',
            },
            availableFormulas: ['PRICE', 'SAC'],
        };
    },

    computed: {
        configPosOne() {
            const config = this.simulatorConfig?.type_installment_configs.find(config => config.position === 1);

            return {
                label: config?.label ?? 'Entrada',
                periodicity: this.periodicityOptions[config?.periodicity ?? 1],
                show: config?.show ?? true,
                paymentForm: this.paymentForms.find(item => item.id = config.default_payment_form_id)?.text,
                backgroundColor: config?.background_color,
                minInstallmentsForInterest: config?.min_installments_for_interest,
                initialInterestInstallment: config?.initial_interest_installment,
                minQuantityInstallment: config?.min_quantity_installment,
                maxQuantityInstallment: config?.max_quantity_installment,
                interest: (config?.interest ?? 0) * 100,
            };
        },

        configPosTwo() {
            const config = this.simulatorConfig?.type_installment_configs.find(config => config.position === 2);

            console.log('config --> ', config);
            return {
                label: config?.label ?? 'Entrada',
                periodicity: this.periodicityOptions[config?.periodicity ?? 2],
                show: config?.show ?? true,
                paymentForm: this.paymentForms.find(item => item.id = config.default_payment_form_id)?.text,
                backgroundColor: config?.background_color,
                minInstallmentsForInterest: config?.min_installments_for_interest,
                initialInterestInstallment: config?.initial_interest_installment,
                minQuantityInstallment: config?.min_quantity_installment,
                maxQuantityInstallment: config?.max_quantity_installment,
                interest: (config?.interest ?? 0) * 100,
            };
        },

        configPosThree() {
            const config = this.simulatorConfig?.type_installment_configs.find(config => config.position === 3);

            return {
                label: config?.label ?? 'Entrada',
                periodicity: this.periodicityOptions[config?.periodicity ?? 3],
                show: config?.show ?? true,
                paymentForm: this.paymentForms.find(item => item.id = config.default_payment_form_id)?.text,
                backgroundColor: config?.background_color,
                minInstallmentsForInterest: config?.min_installments_for_interest,
                initialInterestInstallment: config?.initial_interest_installment,
                minQuantityInstallment: config?.min_quantity_installment,
                maxQuantityInstallment: config?.max_quantity_installment,
                interest: (config?.interest ?? 0) * 100,
            };
        },

        configPosFour() {
            const config = this.simulatorConfig?.type_installment_configs.find(config => config.position === 4);

            return {
                label: config?.label ?? 'Entrada',
                periodicity: this.periodicityOptions[config?.periodicity ?? 4],
                show: config?.show ?? true,
                paymentForm: this.paymentForms.find(item => item.id = config.default_payment_form_id)?.text,
                backgroundColor: config?.background_color,
                minInstallmentsForInterest: config?.min_installments_for_interest,
                initialInterestInstallment: config?.initial_interest_installment,
                minQuantityInstallment: config?.min_quantity_installment,
                maxQuantityInstallment: config?.max_quantity_installment,
                interest: (config?.interest ?? 0) * 100,
            };
        },

        configPosFive() {
            const config = this.simulatorConfig?.type_installment_configs.find(config => config.position === 5);

            return {
                label: config?.label ?? 'Entrada',
                periodicity: this.periodicityOptions[config?.periodicity ?? 5],
                show: config?.show ?? true,
                paymentForm: this.paymentForms.find(item => item.id = config.default_payment_form_id)?.text,
                backgroundColor: config?.background_color,
                minInstallmentsForInterest: config?.min_installments_for_interest,
                initialInterestInstallment: config?.initial_interest_installment,
                minQuantityInstallment: config?.min_quantity_installment,
                maxQuantityInstallment: config?.max_quantity_installment,
                interest: (config?.interest ?? 0) * 100,
            };
        },

        maskPattern() {
            return this.simulatorConfig.entrance_fixed ? '#########.##' : ['##.##', '###.##'];
        },

        configPercentageValue() {
            return {
                max: 100,
                prefix: '',
                decimal: '.',
                number: true,
                thousands: '',
                masked: false,
                suffix: '%',
                precision: 4,
                disabled: false,
                minimumNumberOfCharacters: 0,
            };
        },

        minEntrance() {
            if (!this.simulatorConfig) return 0;
            return this.simulatorConfig.entrance_fixed
                ? parseFloat(this.simulatorConfig.entrance_value)
                : 0;
        },

        minRegularInstallments() {
            const regular = this.simulatorConfig?.type_installment_configs?.find(
                config => config.label.toLowerCase().includes('parcelas regulares'),
            );
            return regular?.min_quantity_installment || 1;
        },

        maxRegularInstallments() {
            const regular = this.simulatorConfig?.type_installment_configs?.find(
                config => config.label.toLowerCase().includes('parcelas regulares'),
            );
            return regular?.max_quantity_installment || null;
        },

        minIntermediateInstallments() {
            const intermediate = this.simulatorConfig?.type_installment_configs?.find(
                config => config.label.toLowerCase().includes('intermediária'),
            );
            return intermediate?.min_quantity_installment || 1;
        },

        maxIntermediateInstallments() {
            const intermediate = this.simulatorConfig?.type_installment_configs?.find(
                config => config.label.toLowerCase().includes('intermediária'),
            );
            return intermediate?.max_quantity_installment || null;
        },
    },

    methods: {
        setConfigTablePrice(config) {
            this.simulatorConfig = config;
            console.log('simulatorConfig --> ', this.simulatorConfig);

            this.inputPosOne.value = this.simulatorConfig.entrance_value;
            this.inputPosOne.periodicity = this.configPosOne.periodicity;

            setTimeout(() => {
                this.loading = false;
            }, 500);

            this.getPaymentMethods();
        },

        getPaymentMethods() {
            paymentMethods.list()
                .then(resp => {
                    this.paymentForms = resp.data;
                    console.log('this.paymentForms --> ', this.paymentForms);
                })
                .catch(err => this.errorMsg(err));
        },

        checkValidateEntranceValue() {
            if (this.inputPosOne.value < this.simulatorConfig.entrance_value) {
                console.log('aqui 1');
                this.inputPosOne.value = this.simulatorConfig.entrance_value;
            }

            if (!this.simulatorConfig.entrance_fixed && this.inputPosOne.value > 100) {
                console.log('aqui 2');
                this.inputPosOne.value = 10000;
            }
        },

        getLabelValue() {
            console.log('this.configPosOne --> ', this.configPosOne);
            if (this.simulatorConfig.entrance_fixed) {
                console.log('haaaaa');
            } else {
                // const value = (this.simulatorConfig.entrance_value/100).toLocaleString('pt-BR', {
                //     style: 'percent',
                //     minimumFractionDigits: 2
                // });

                return `${this.simulatorConfig.entrance_value.toFixed(2)}%`;
            }

            return `Valor Mínimo de ${this.configPosOne.label}`;
        },

        widthMd(size = 1025, smaller = '<') {
            if (smaller == '<') {
                return window.innerWidth < size;
            } else {
                return window.innerWidth > size;
            }
        },

        async generatePriceTable() {
            try {
                this.loading = true;

                const payload = {
                    ...this.formValues,
                };

                const response = await this.$http.post('/api/generate-price-table', payload, {
                    responseType: 'blob',
                });

                // Se a resposta for um arquivo para download
                if (response.headers['content-type'] === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `tabela_precos_${this.allotmentId}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();

                    this.$toast.success('Tabela de preços gerada com sucesso!');
                    this.$emit('close');
                } else {
                    this.$toast.error('Formato de resposta inesperado do servidor');
                }
            } catch (error) {
                console.error('Erro ao gerar tabela de preços:', error);
                this.$toast.error(error.response?.data?.message || 'Erro ao gerar tabela de preços');
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped>
.modal-height-max {
    max-height: 90vh;
    overflow-y: auto;
}

.config-details {
    margin-top: 1.5rem;
    padding: 1rem;
    border: 1px solid #e0e0e0;
    border-radius: 0.5rem;
    background-color: #f8f9fa;
}

.form-label {
    font-weight: 500;
    margin-bottom: 0.5rem;
    display: block;
}

.input-group-text {
    min-width: 40px;
    justify-content: center;
}

.btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.btn i {
    margin-right: 0.5rem;
}

.text-muted {
    font-size: 0.75rem;
    display: block;
    margin-top: 0.25rem;
}

.card {
    border: none;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.card-header {
    background-color: #f8f9fa;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    padding: 1rem 1.25rem;
}

.card-title {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 500;
}

.card-body {
    padding: 1.5rem;
}
</style>
